import React from 'react';

export default function Seo() {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', paddingTop:'2rem' }}>
      <h2>SEO</h2>
    </div>
  );
}
